import Vue from 'vue'

export var eventHub = new Vue();